import { render, staticRenderFns } from "./ComplaintList.vue?vue&type=template&id=3fb3fd9b&scoped=true"
import script from "./ComplaintList.vue?vue&type=script&lang=js"
export * from "./ComplaintList.vue?vue&type=script&lang=js"
import style0 from "./ComplaintList.scss?vue&type=style&index=0&id=3fb3fd9b&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb3fd9b",
  null
  
)

export default component.exports